import ComplaintsByCohortPage from './ComplaintsByCohortPage';
import withIngestBatchEvents from './containers/withIngestBatchEvents';
import * as dashboards from './dashboards';
import EngagementRateByCohortPage from './EngagementRateByCohortPage';
import EngagementRecencyPage from './EngagementRecencyPage';
import HealthScorePage from './HealthScorePage';
import IntegrationPage from './IntegrationPage';
import ResourceDetailsPage from './ResourceDetailsPage';
import SpamTrapPage from './SpamTrapPage';
import UnsubscribeRateByCohortPage from './UnsubscribeRateByCohortPage';

export default {
  ResourceDetailsPage,
  ComplaintsByCohortPage,
  EngagementRateByCohortPage,
  EngagementRecencyPage,
  HealthScorePage,
  SpamTrapPage,
  UnsubscribeRateByCohortPage,
  IntegrationPage: withIngestBatchEvents(IntegrationPage),
  ...dashboards
};
